import { COMPLETED_RESPONSE_REVEAL_MAX_CHUNK_SIZE, RESPONSE_PROGRESS_MESSAGES } from './constants';

export const shuffleResponseProgressMessages = (lastMessage: null | string) => {
  const messages = [...RESPONSE_PROGRESS_MESSAGES];

  for (let index = messages.length - 1; index > 0; index -= 1) {
    const randomIndex = Math.floor(Math.random() * (index + 1));
    [messages[index], messages[randomIndex]] = [messages[randomIndex], messages[index]];
  }

  if (lastMessage && messages[0] === lastMessage) {
    const swapIndex = 1 + Math.floor(Math.random() * (messages.length - 1));
    [messages[0], messages[swapIndex]] = [messages[swapIndex], messages[0]];
  }

  return messages;
};

export const splitAssistantMessageSegments = (value: string) =>
  value
    .split(/\n{2,}/)
    .map((segment) => segment.trim())
    .filter(Boolean);

export const getNextRevealCount = (content: string, currentCount: number) => {
  const remainingCount = content.length - currentCount;
  const baseChunkSize = Math.max(
    2,
    Math.min(COMPLETED_RESPONSE_REVEAL_MAX_CHUNK_SIZE, Math.ceil(remainingCount / 70))
  );
  const tentativeEnd = Math.min(content.length, currentCount + baseChunkSize);
  const nearbyWhitespaceOffset = content.slice(tentativeEnd, tentativeEnd + 9).search(/\s/);

  return nearbyWhitespaceOffset >= 0
    ? Math.min(content.length, tentativeEnd + nearbyWhitespaceOffset + 1)
    : tentativeEnd;
};
